<template>
  <div class="md:flex md:items-center md:justify-between mb-3">
    <div class="flex-1 min-w-0">
      <h2 class="text-2xl leading-7 text-gray-900 sm:text-3xl sm:truncate">
        Facture - Export
      </h2>

    </div>
    <div
        class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-reverse sm:space-y-0 sm:space-x-3 md:mt-0 md:flex-row md:space-x-3">
      <div class="flex-1 flex justify-between sm:justify-end">
        <a @click=pdfExport v-if="!pdfExportInProgress" href="#"
           class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          Demander un export
        </a>

        <button type="button" v-if="pdfExportInProgress"
                class="ml-3 relative inline-flex items-center font-bold px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                disabled="">
          <svg class="animate-spin h-5 w-5 text-indigo-500"
               xmlns="http://www.w3.org/2000/svg" fill="none"
               viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>

        </button>

      </div>
    </div>
    <div class="mt-4 flex md:mt-0 md:ml-4">
      <div class="relative rounded-md shadow-sm">
      </div>
      <Menu as="div" class="ml-3 relative inline-block text-left">
        <div>
        </div>

        <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
          <MenuItems
              class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none">
            <div class="py-1">
              <MenuItem v-slot="{ active }">
                <a @click=pdfExport href="#"
                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                  <PencilAltIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true"/>
                  Export PDF
                </a>
              </MenuItem>
              <MenuItem v-slot="{ active }">
                <a href="#"
                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                  <DuplicateIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true"/>
                  Export Google Sheet
                </a>
              </MenuItem>
            </div>
            <div class="py-1">
              <MenuItem v-slot="{ active }">
                <a href="#"
                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                  <ArchiveIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true"/>
                  Numéroter
                </a>
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Menu>

    </div>
  </div>
  <div class="mt-0 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-hidden sm:-mx-6 lg:-mx-8 grid mt-1">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
          <InvoiceExportGrid
              :data1="gridData"
              :columns="gridColumns"
              :columns-displayed="gridColumnsDisplayed"
              :filter-key="searchQuery"
              :page="1"
              :per-page="8"
              :pages="[]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {TransitionRoot} from '@headlessui/vue'
import {CheckCircleIcon, ChevronRightIcon, MailIcon, ExclamationCircleIcon} from '@heroicons/vue/solid'
import {CreditCardIcon, OfficeBuildingIcon, SearchIcon, UserIcon, UsersIcon} from '@heroicons/vue/solid'

import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import {
  ArchiveIcon,
  ArrowCircleRightIcon,
  ChevronDownIcon,
  DuplicateIcon,
  HeartIcon,
  PencilAltIcon,
  TrashIcon,
  UserAddIcon,
} from '@heroicons/vue/solid'
import {ref} from 'vue'
import {notify, Notification, NotificationGroup} from 'notiwind'
import InvoiceExportGrid from "@/components/invoice/InvoiceExportGrid";

const tabs = []
</script>


<script>
import InvoiceUpload from './InvoiceUpload.vue'
import axios from "axios";
import moment from 'moment'
import {usePost} from "@/composables/fetch";
import {XIcon} from '@heroicons/vue/solid'
import router from "@/router";

export default {
  components: {},
  props: {
    endpoint: String,
  },
  data() {
    return {
      show: 1,
      notifications: "",
      token: null,
      showUpload: false,
      gridColumnsDisplayed: {
        id: "#",
        invoice_count: "Facture",
        file_count: "Fichiers",
        fiscal_year: "Exercice Fiscal",
        user: "Utilisateur",
        status: "Status",
        created_at: "Date",
        button: ''
      },
      gridColumns: ['id', 'company_name', 'date'],
      gridData: [],
      searchQuery: '',
      polling: null,
      pdfExportInProgress: false
    }
  },
  watch: {
    '$route': {
      handler: function (val, oldVal) {
        clearInterval(this.polling);
        this.searchQuery = this.getFromLocalStorage('filterKey')
        this.fetchInvoiceData()
        this.intervalFetchData()
      },
      immediate: true,
      deep: true
    },
  },
  beforeUnmount() {
    clearInterval(this.polling)
  },
  methods: {
    async pdfExport() {
      this.pdfExportInProgress = true
      const token = await this.$auth.getAccessTokenSilently();

      const data = {
        fiscal_year_id: 3,
        user_id: 37,
      }

      await usePost("invoice/pdf/export", data, token)
      await this.fetchInvoiceData()
    },

    intervalFetchData: function () {
      this.polling = setInterval(() => {
        this.fetchInvoiceData();
      }, 10000);
    },
    saveToLocalStorage(item, value) {
      localStorage.setItem(item, value);
    },
    getFromLocalStorage(item) {
      return localStorage.getItem(item);
    },

    async fetchInvoiceData() {
      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      let gridData = [];
      HTTP.get(this.endpoint)
          .then(response => {
            const invoices = response.data
            invoices.forEach((value) => {

              value['status'] === 'pending' ? this.pdfExportInProgress = true : '';

              gridData.push({
                id: value['id'],
                invoice_count: value['invoice_count'] ? value['invoice_count'] : null,
                file_count: value['file_count'] ? value['file_count'] : null,
                fiscal_year: value['fiscal_year'] ? value['fiscal_year']['name'] : null,
                user: value['user'] ? value['user']['name'] : null,
                status: value['status'] ? value['status'] : null,
                file_name: value['file_name'] ? value['file_name'] + " €" : null,
                file_url: value['file_url'] ? value['file_url'] : null,
                created_at: value['created_at'] ? moment(value['created_at']).format('YYYY-MM-DD') : null,
                button: value['id']
              })
            });
            this.gridData = gridData;
          }).catch(e => {
        console.log(e)
      })
    },
    truncate(v) {
      const newline = v.indexOf('\n')
      return newline > 0 ? v.slice(0, newline) : v
    },
    formatDate(v) {
      return v.replace(/T|Z/g, ' ')
    }
  }
}
</script>
